import { useEffect, useState } from "react";
import api, { fmtDateTime } from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { amdenNav } from "@/lib/navConfig";
import { PageHeader } from "@/components/Common";

export default function SupportAccess() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/support/access-history").then((r) => setRows(r.data)); }, []);
  return (
    <AdminLayout nav={amdenNav} title="Support Access">
      <PageHeader title="Support Access History" subtitle="Every impersonation session is recorded" />
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs font-semibold uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <th className="p-3">Amden User</th><th className="p-3">Impersonated</th><th className="p-3">Started</th><th className="p-3">Ended</th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-zinc-400">No support sessions yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-zinc-50 hover:bg-zinc-50">
                <td className="p-3 font-medium">{r.amden_email}</td>
                <td className="p-3">{r.target_name} <span className="text-xs text-zinc-400">({r.target_email})</span></td>
                <td className="p-3 num text-xs">{fmtDateTime(r.started_at)}</td>
                <td className="p-3 num text-xs">{r.ended_at ? fmtDateTime(r.ended_at) : <span className="text-amber-600 font-semibold">ACTIVE</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
